export default "__VITE_ASSET__BjKEKW5H__"